import {AllStatisticsDashboard} from './AllStatisticsDashboard';
export default AllStatisticsDashboard;
